export default "__VITE_ASSET__DC0Tb5Xq__"